import Flickity from 'flickity';
import imagesLoaded from 'flickity-imagesloaded';

const carousels = document.querySelectorAll('[data-carousel]')

const productCarousels = document.querySelectorAll('[data-slider-container]');

const accordions = document.querySelectorAll('input[name="accordion"]')

if (carousels.length > 0) {
  carousels.forEach(carousel => {
    const { carouselButtons: buttons = false, carouselDots: dots = false, carouselAlign: align = 'center', carouselAutoplay: autoplay = false } = carousel.dataset
    const flickity = new Flickity(carousel, {
      autoPlay: autoplay ? 4500 : false,
      cellAlign: align,
      contain: true,
      groupCells: dots ? true : false,
      pageDots: dots,
      prevNextButtons: buttons,
      wrapAround: true,
    })
  })
}

if (productCarousels.length > 0) {

  productCarousels.forEach(carousel => {
    const { carouselButtons: buttons = true, carouselDots: dots = false, carouselAlign: align = 'left', carouselAutoplay: autoplay = false } = carousel.dataset
    const flickity = new Flickity(carousel, {
      autoPlay: autoplay ? 4500 : false,
      cellAlign: align,
      contain: true,
      groupCells: true,
      pageDots: dots,
      prevNextButtons: buttons,
      wrapAround: false,
      imagesLoaded: true,
    })
    const ready = function () {
      window.setTimeout(
        function () {
          const i = carousel.querySelector('.active-thumb') ? carousel.querySelector('.active-thumb').parentNode.dataset.sliderSlideIndex : null;
          flickity.select(0)
          carousel.querySelectorAll('.product-single__thumbnails-item').forEach((slide) => {
            if (slide.dataset.sliderSlideIndex !== i && slide.dataset.colorImg != '*') {
              slide.classList.add('hide');
            } else {
              slide.classList.remove('hide')
            }
          })
          flickity.reposition();
        }, 275
      )
    }
    flickity.on('ready', ready())
    document.querySelectorAll('.single-option-selector').forEach(el => {
      el.addEventListener('change', (e) => {
        ready()
      });
    })
  });
}

if (accordions.length > 0) {
  accordions.forEach(input => {
    input.addEventListener('click', (e) => {
      if (e.currentTarget.classList.contains('checked')) {
        e.currentTarget.classList.remove('checked')
        e.currentTarget.checked = false
      } else {
        e.currentTarget.classList.add('checked')
      }
    })
  })
}